import el from "@cypherpotato/el";
import { randomId } from "../util";

export function SpecializedControl({ fields, value }) {
    const uniqId = randomId();

    return el(".specialized-object",
        ...fields.map(field =>
            field.name && el(".specialized-field",
                {
                    dataUniqId: uniqId,
                    dataFieldName: field.name,
                    $properties: {
                        value: {
                            get() {
                                return field.control.value;
                            },
                            set(value) {
                                field.control.value = value;
                            }
                        }
                    }
                },
                el("label", field.label),
                el("div",
                    field.control,
                    {
                        init() {
                            if (value && value[field.name]) {
                                field.control.value = value[field.name];
                            }
                        }
                    }
                )
            ) || field
        ),
        {
            $properties: {
                value: {
                    get() {
                        const result = {};
                        for (const field of this.querySelectorAll(`.specialized-field[data-uniq-id="${uniqId}"]`)) {
                            result[field.dataset.fieldName] = field.value;
                        }

                        return result;
                    }
                }
            }
        }
    );
}